import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-control-supporting-text',
  templateUrl: './control-supporting-text.component.html',
  styleUrls: ['./control-supporting-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass]
})
export class ControlSupportingTextComponent {

  control = input.required<AbstractControl | null>();
  controlName = input.required<string>();
  isValid = input.required<boolean>();
  calculateValidationText = input<CalculateValidationTextFn | string>();
  helpText = input<string>();

  getSupportingText(): string {
    let text: string;

    if (this.isValid()) {
      text = this.helpText();
    }
    else {
      text = `${this.controlName()} is invalid`;

      const controlErrors = this.control()?.errors;
      if (controlErrors) {
        if (controlErrors.required) {
          text = `${this.controlName()} is required`;
        } else if (controlErrors.minlength) {
          text = `${this.controlName()} must be at least ${controlErrors.minlength.requiredLength} characters long`;
        } else if (controlErrors.maxlength) {
          text = `${this.controlName()} can not be more than ${controlErrors.maxlength.requiredLength} characters long`;
        } else if (controlErrors.email) {
          text = `${this.controlName()} does not contain a valid email address`;
        } else if (controlErrors.pattern) {
          text = `${this.controlName()} does not match the reg-ex pattern`;
        } else if (controlErrors.unique) {
          text = `${this.controlName()} must be unique`;
        } else if (controlErrors.dateRange) {
          text = controlErrors.dateRange;
        }
      }

      if (this.calculateValidationText()) {
        const calculatedValidationText = this.calculateValidationText();

        if (typeof calculatedValidationText === 'string' || calculatedValidationText instanceof String) {
          text = calculatedValidationText as string;
        }
        else {
          text = calculatedValidationText(this.control(), text) ?? text;
        }
      }
    }

    return text;
  }

}

export type CalculateValidationTextFn = (control: AbstractControl, defaultValidationText: string) => string;
